var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3804 33.0388C30.3804 34.6756 24.8341 35.9975 17.9998 35.9975C11.1654 35.9975 5.61914 34.6756 5.61914 33.0388C5.61914 31.5763 10.0629 30.3725 15.8904 30.125H20.1091C25.9423 30.3725 30.3804 31.5763 30.3804 33.0388Z",
    fill: "#E3E2E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C11.6437 0 6.49121 5.14688 6.49121 11.5031C6.49121 17.8594 18 33.0413 18 33.0413C18 33.0413 29.5031 17.8594 29.5031 11.5031C29.5031 5.14688 24.3562 0 18 0ZM18 19.1194C13.7925 19.1194 10.3837 15.7106 10.3837 11.5031C10.3837 7.29563 13.7925 3.88687 18 3.88687C22.2075 3.88687 25.6162 7.29563 25.6162 11.5031C25.6162 15.7106 22.2075 19.1194 18 19.1194Z",
    fill: "#171C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeLoc);
export default __webpack_public_path__ + "static/media/customize-loc.128d5bb419e6ddda48393a4c7867f381.svg";
export { ForwardRef as ReactComponent };